const companyTypes = ['carrier', 'customer', 'receiver', 'shipper'];

export default companyTypes;